import { alpha, Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { MainInput, MainButton, DefaultButton, ErrorButton } from "../index";
import { Constants } from "../../utils/constants";
import { useEffect, useState } from "react";

export default function ProjectUrlDeleteModal({
    open,
    onClose,
    onFinish,
    record,
}) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 360,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };

    useEffect(() => {
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-project-create-title"
            aria-describedby="modal-project-create-description"
        >
            <Box sx={style}>
                <Stack
                    spacing={"2.5rem"}
                    direction={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        spacing={2}
                    >
                        <Box
                            sx={{
                                width: "2.5rem",
                                height: "2.5rem",
                                borderRadius: "50%",
                                border: `3px solid ${Constants.Colors[currentMode].warning}`,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <ErrorOutlineOutlinedIcon sx={{
                                color: Constants.Colors[currentMode].warning,
                                fontSize: 24,
                            }} />
                        </Box>
                        <Typography variant="h6" align="center">
                            {`Confirm url deletion`}
                        </Typography>
                    </Stack>
                    <Stack direction={"row"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        spacing={2}
                        sx={{
                            width: "100%",
                        }}
                    >
                        <DefaultButton
                            text={"Cancel"}
                            onClick={onClose}
                            size="medium"
                            fullWidth={false}
                        />
                        <ErrorButton
                            text={"Delete URL"}
                            onClick={() => {
                                onFinish(record);
                            }}
                            size="medium"
                            fullWidth={false}
                        />
                    </Stack>


                </Stack>
            </Box>
        </Modal>
    );
}